import { useSelector } from "react-redux";
import { StoreState } from "../models/states/StoreState";
import { getCurrentBlock } from "../redux/reducers/interview/navigationUtilities";

export default function useBlock() {
    return useSelector((state: StoreState) => getCurrentBlock(state.interview.navigation));
}
